import {
  ALL_HALLS_OPTION_ID,
  IPlannerFiltersState,
  isAllHallsSelected,
} from "../models/plannerFilters";
import { ISelectFieldModel } from "../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";
import { IPlannerEventModel } from "../models/plannerEventModel";

const PLANNER_FILTERS_STORAGE_KEY = "planner_filters";

export const loadFiltersFromStorage = (): Partial<IPlannerFiltersState> => {
  try {
    const stored = localStorage.getItem(PLANNER_FILTERS_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored) as Partial<IPlannerFiltersState>;
      // Older stored state may not have selectedHallIds; treat missing as "all".
      if (!Array.isArray(parsed.selectedHallIds)) {
        parsed.selectedHallIds = [ALL_HALLS_OPTION_ID];
      }
      return parsed;
    }
  } catch {}
  return {};
};

export const saveFiltersToStorage = (filters: IPlannerFiltersState): void => {
  try {
    localStorage.setItem(PLANNER_FILTERS_STORAGE_KEY, JSON.stringify(filters));
  } catch {}
};

export const updateInstructorLabels = (
  currentFilters: IPlannerFiltersState,
  studioEmployees: ISelectFieldModel[] | undefined
): IPlannerFiltersState | null => {
  if (!studioEmployees || currentFilters.selectedInstructors.length === 0) {
    return null;
  }

  const updatedInstructors = currentFilters.selectedInstructors.map(selectedInstructor => {
    const fullInstructor = studioEmployees.find(emp => emp.id === selectedInstructor.id);
    return fullInstructor || selectedInstructor;
  });

  const hasChangedLabels = updatedInstructors.some((instructor, index) =>
    instructor.name !== currentFilters.selectedInstructors[index].name
  );

  if (hasChangedLabels) {
    return {
      ...currentFilters,
      selectedInstructors: updatedInstructors
    };
  }

  return null;
};

export const filterEventsByFilters = (
  events: IPlannerEventModel[] | undefined,
  filters: IPlannerFiltersState
): IPlannerEventModel[] | undefined => {
  if (!events || events.length === 0) return events;

  let filteredEvents = events;

  // Filter out deleted events by default (unless showDeletedEvents is true)
  if (!filters.showDeletedEvents) {
    filteredEvents = filteredEvents.filter(event => !event.isCancelled);
  }

  if (filters.selectedInstructors.length > 0) {
    const instructorIds = filters.selectedInstructors.map(employee => employee.id);
    filteredEvents = filteredEvents.filter(event =>
      instructorIds.includes(event.employeeId)
    );
  }

  if (filters.selectedEventTypes.length > 0) {
    filteredEvents = filteredEvents.filter(event =>
      filters.selectedEventTypes.includes(event.type)
    );
  }

  if (!isAllHallsSelected(filters.selectedHallIds)) {
    filteredEvents = filteredEvents.filter(
      event => event.studioHallId != null && filters.selectedHallIds.includes(event.studioHallId)
    );
  }

  return filteredEvents;
};
